import { inject, Injectable } from '@angular/core';
import { ImportantNoticeService } from '@reconcept-platform/shared/app/core';
import { ImportantNoticeApplicationEnum } from '@reconcept-platform/shared/types';
import { take, tap } from 'rxjs/operators';
import { WorkspaceViewerService } from './workspace-viewer.service';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceViewerResolver {
  private viewerService = inject(WorkspaceViewerService);
  private importantNoticeService = inject(ImportantNoticeService);

  // queries the current viewer and sets it in viewerservice to persist
  resolve() {
    return this.viewerService.getViewer().pipe(
      take(1),
      tap((viewer) => {
        if (viewer.importantNotices?.length > 0) {
          this.importantNoticeService.checkImportantNotice(viewer, ImportantNoticeApplicationEnum.WORKSPACE_DASHBOARD);
        }
      }),
    );
  }
}
